
    <div class="container-reschedule">
        <h2 class="heading">{{title}}</h2>
        <div class="banner-duration">Reschedule Banner Duration</div>
        <form id="reschedule-form">
            <label for="start-date">From</label>
          <div class="form-group">
            <button class="" class="reschedule-date-button" id="reportrange" type="button">
              <span class="img">
                  <img src="assets/calender.svg">
              </span>
              <input matInput [min]="minEndDate" [matDatepicker]="picker1" class="text" style="background-color:transparent;border: 0px solid;"
              required [formControl]="startDateForm">
              <mat-datepicker-toggle matSuffix [for]="picker1" class="icon">
                  <mat-icon  matDatepickerToggleIcon style=" color: #386AF6">arrow_drop_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
          </button>
          <input type="time" id="start-time" name="start-time" style="font-size: 14px;" required [(ngModel)]="startTime">
        </div>
          <label for="end-date">To</label>
          <div class="form-group">
            <button class="" class="reschedule-date-button" id="reportrange" type="button">
              <span class="img">
                  <img src="assets/calender.svg">
              </span>
              <input matInput [min]="minEndDate" [matDatepicker]="picker2" class="text" style="background-color:transparent;border: 0px solid;"
              required
              [formControl]="endDateForm">
              <mat-datepicker-toggle matSuffix [for]="picker2" class="icon">
                  <mat-icon matDatepickerToggleIcon style=" color: #386AF6">arrow_drop_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
          </button>
            <input type="time" id="end-time" name="end-time" style="font-size: 14px;" required [(ngModel)]="endTime">
          </div>
          <div class="form-btn">
            <button class="cancel-btn" (click)="closePopUp()">Cancel</button>
            <button class="save-btn" (click)="rescheduleBanner()">Save</button>
          </div>
        </form>
    </div>
